import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 30000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从store获取token
    const token = store.getters.token
    if (token) {
      config.headers['X-Admin-Token'] = token
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 根据返回的code判断
    if (res.code === 200 || res.code === 0) {
      return res
    } else {
      Message({
        message: res.message || '请求失败',
        type: 'error',
        duration: 5 * 1000
      })
      
      // 401: 未登录或token过期
      // 只有在有token的情况下才执行logout，避免登录失败时调用logout
      if (res.code === 401 && store.getters.token) {
        store.dispatch('user/resetToken').then(() => {
          router.push('/login')
        })
      }
      
      return Promise.reject(new Error(res.message || '请求失败'))
    }
  },
  error => {
    console.error('响应错误:', error)

    // 提取错误信息
    let message = '网络错误'
    if (error.response) {
      // 服务器返回了响应,但状态码不在 2xx 范围内
      if (error.response.data && error.response.data.message) {
        message = error.response.data.message
      } else if (error.response.status === 400) {
        message = '请求参数错误'
      } else if (error.response.status === 401) {
        message = '未授权,请重新登录'
      } else if (error.response.status === 403) {
        message = '拒绝访问'
      } else if (error.response.status === 404) {
        message = '请求资源不存在'
      } else if (error.response.status === 500) {
        message = '服务器内部错误'
      }
    } else if (error.message) {
      message = error.message
    }

    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
